var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "tag_svg__a",
    width: 19,
    height: 19,
    x: 0,
    y: 0,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15.854 4.618c-.117-.756-.891-1.562-1.664-1.645l-3.407-.355c-.178-.017-.321-.03-.43-.038l-.181-.012c-.55-.02-1.104.214-1.544.655l-6.862 6.862a1.819 1.819 0 0 0 .01 2.558l4.548 4.549c.613.613 1.818.623 2.496-.054l6.861-6.862c.4-.399.608-1.02.55-1.672l-.175-1.992a83.793 83.793 0 0 0-.168-1.729l-.034-.265Zm-3.721-.884 1.952.208.081.017c.305.092.677.5.725.808l.031.248.146 1.497.192 2.177.006.123c0 .323-.107.607-.274.775L8.13 16.448c-.294.294-.882.29-1.116.055l-4.55-4.55a.844.844 0 0 1-.008-1.18l6.861-6.86c.255-.256.55-.38.82-.37l.473.038 1.523.153Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.321 8.393a1.987 1.987 0 1 0-2.81-2.81 1.987 1.987 0 0 0 2.81 2.81Zm-2.12-2.121a1.013 1.013 0 1 1 1.431 1.432A1.013 1.013 0 0 1 11.2 6.272Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tag_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.5.924h18v18H.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.f25aa9e2.svg";
export { ForwardRef as ReactComponent };